import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const VerktygHub = lazy(() => import("@/pages/verktyg/VerktygHub"));

export const Route = createFileRoute("/verktyg/")({
  head: () => seoHead("/verktyg", { description: "Smarta verktyg som hjälper dig hitta rätt elavtal, rätt elbolag, kontrollera ditt elområde och optimera din förbrukning." }),
  component: () => <VerktygHub />,
});
